// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './EllipsisTextPopup.scss'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const EllipsisTextPopup = ({ children, className, style }) => {
  return (
    <div className={`ellipsis-text-popup ${className}`} style={style}>
      {children}
    </div>
  )
}
